import type { ReactNode } from "react";

type SectionTitleProps = {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  action?: ReactNode;
};

export default function SectionTitle({ eyebrow, title, description, action }: SectionTitleProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <span className="h-1.5 w-1.5 rounded-full bg-secondary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">{title}</h2>
        {description && <p className="mt-2 text-sm leading-relaxed text-foreground-600">{description}</p>}
      </div>
      {action}
    </div>
  );
}